package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.db.ReleaseTypeData
import com.neurobs.ccab.ReleaseDataRest
import com.neurobs.js.view._
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.DOMViewElement._
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._
import scala.collection.mutable.ArrayBuffer

class ReleaseListView (releaseType: ReleaseTypeData) {
	import ReleaseListView._

	def makeUploadForm(): CreateForm = {
		val boxWidth = 20
		val formWidth = 60

		val versionBox = makeTextInput(boxWidth)
		val minDependencyBox = makeTextInput(boxWidth)
		val fileBox = new FileSelectSpan
		val rows = ArrayBuffer[(HTMLElement, HTMLElement)](("Version:", versionBox))
		releaseType.dependency1Description.foreach(d => rows += ((s"Minimum $d Version", minDependencyBox)))
		rows += ((s"${releaseType.displayName}:", fileBox.element))
		val form = makeForm(
			width = formWidth,
			title = s"New ${releaseType.displayName} Release",
			description = "",
			elements = rows.toArray,
			useCancel = true,
			submitCaption = "Upload"
		)
		CreateForm(form, versionBox, minDependencyBox, fileBox)
	}

	def makeUpdateForm(r: ReleaseDataRest): UpdateForm = {
		val boxWidth = 20
		val formWidth = 60

		val notesBox = textarea(style := s"width:${boxWidth}em;height:5em;").render
		val minDependencyBox = makeTextInput(boxWidth)
		val releaseDateBox = makeTextInput(boxWidth)
		val activeBox = makeCheckbox()

		val rows = ArrayBuffer[(HTMLElement, HTMLElement)](("Active:", activeBox), ("Release Date (YYYY-MM-DD):", releaseDateBox))
		releaseType.dependency1Description.foreach(d => rows += ((s"Minimum $d Version:", minDependencyBox)))
		rows += (("Release Notes:", notesBox))
		val form = makeForm(
			width = formWidth,
			title = s"Update ${releaseType.displayName} ${r.version}",
			description = "",
			elements = rows.toArray,
			useCancel = true,
			submitCaption = "Update"
		)
		UpdateForm(form, releaseDateBox, activeBox,  minDependencyBox, notesBox)
	}

	private def escapeForHTML(s: String): String = {
		div(s).render.innerHTML.replace("\n", "<br>")
	}

	def makeNotesDialog(version: String, notes: String): MessageBox = {
		val content = {
			val bodyTag = "<body>"
			val s = notes.indexOf(bodyTag)
			val e = notes.indexOf("</body>")
			if ( (s != -1) && (e > s) )
				div(style := "display:inline-block;text-align: left;", raw(notes.substring(s + bodyTag.length, e))).render
			else {
				div(style := "text-align: left", raw(escapeForHTML(notes))).render
			}
		}
		makeSimpleMessageDialog(40, s"$version Release Notes", "", "Close", Some(content))
	}
}

object ReleaseListView {

	case class CreateForm(form: Form, versionBox: TextBox, minDependencyBox: TextBox, fileBox: FileSelectBox)

	case class UpdateForm(form: Form, releaseDateBox: TextBox, activeBox: CheckBox, minDependencyBox: TextBox, notesBox: TextBox)

	case class ReleaseInfo(version: Text, active: Text, created: Text, url: Link, minVersion: Option[Text], editLink: Link, notesLink: Link, deleteLink: Link)
}